module.exports = __webpack_public_path__ + "img/SEJ enventos_sede presencial.af86e6ad.svg";